import contractDetail from './contractDetail'

export default {
  status                    : {
    initializing              : false,
    processing              : false,
    error                   : null,
    success                 : null,
    previous                : null
  },
  dashboard: {},
  contractNo: "",
  contractIdsSignInStudentApp: [],
  contract: {},
  contracts: [],
  contractOptions: [],
  contractStatusTransaction: {},
  contractStatusTransactions: [],
  contractsByFilters: [],
  contractsByDashboardLists: [],
  contractsByDashboardListFilters: [],
  contractsByNotificationLists: [],
  contractsByNotificationListFilters: [],
  contractsTrackDownDebtByFilters: [],
  interestRateDetail: {},
  interestRateDetails: [],
  loanDetail: {},
  loanDetails: [],
  suretyDetail: {},
  suretyDetails: [],
  appointmentLog: {},
  appointmentLogs: [],
  loanDetailPlan: {},
  loanDetailPlans: [],
  feeDetail: {},
  feeDetails: [],
  paymentRound: {},
  paymentRounds: [],
  paymentRoundTransaction: {},
  paymentRoundTransactions: [],
  transaction: {},
  transactions: [],
  payment: {},
  payments: [],
  file: {},
  files: [],
  callHistory: {},
  callHistories: [],
  sendSmsHistory: {},
  sendSmsHistories: [],
  sendDocHistory: {},
  sendDocHistories: [],
  lawsuitHistory: {},
  lawsuitHistories: [],
  transactionsLoad: true,
  qrPayment: {},
  ...contractDetail
}
